import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackQuickBouncePage, trackStayMoreThan5Sec } from '../../helper/utils/eventTrackGA';

function StayOnPageTracker() {
    useEffect(() => {
        const timer = trackStayMoreThan5Sec();

        // Cleanup function untuk clear timeout jika user pindah halaman cepat
        return () => clearTimeout(timer);
    }, []);

    return null;
}

function QuickBouncePageTracker() {
    const location = useLocation();

    useEffect(() => {
        const timer = trackQuickBouncePage(location.pathname);

        // Cleanup function untuk clear timeout jika user pindah halaman cepat
        return () => clearTimeout(timer);
    }, [location.pathname]);

    return null;
}

export { QuickBouncePageTracker, StayOnPageTracker };

